import { render, staticRenderFns } from "./Profs.vue?vue&type=template&id=7a7a6e39&"
import script from "./Profs.vue?vue&type=script&lang=js&"
export * from "./Profs.vue?vue&type=script&lang=js&"
import style0 from "./Profs.vue?vue&type=style&index=0&id=7a7a6e39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports